import { RETURN_CODE } from "constants/ReturnCodeConstant";

class ServiceUtils {

	/**
	 * 서비스 결과 확인
	 * @param {*} header 
	 * @returns 
	 */
	static checkResult(header) {
		return header !== undefined ? header.returnCode === RETURN_CODE.OK : false;
	}

	/**
	 * 결제 오류 확인
	 * @param {*} header 
	 * @returns 
	 */
	static checkPaymentError(header) {
		return header !== undefined ? header.returnCode === RETURN_CODE.PAYMENT_ERROR : false;
	}

	/**
	 * 서비스 결과를 확인해서 값 전달
	 * @param {*} header 
	 * @param {*} value 
	 * @returns 
	 */
	static getCheckResultValue(header, value) {
		return header.retuenCode === RETURN_CODE.OK ? value : null;
	}

	static isNotNullAndUndefined(o) {
		return o !== undefined && o !== null;
	}

}

export default ServiceUtils;